import React from 'react';
import GoogleMap from 'google-map-react';
import { useQueryGetRoadDistance } from '../../queries/geo/hooks/useQueryGetRoadDistance';
import './geoDirection.scss';

export const GeoDirection: any = (props: any) => {
  const { refetch: refetchRoadDistance } = useQueryGetRoadDistance({
    skip: true,
    variables: {},
  });
  const {
    origin,
    destination,
    position,
    center,
    zoom = 12,
  } = props;

  const defaultCenter = { lat: 52.301570, lng: 4.796690 };

  const handleGoogleApiLoaded = (map: any, maps: any) => {
    refetchRoadDistance({
      origin: {
        lat: origin.lat,
        lng: origin.lng,
      },
      destination: {
        lat: destination.lat,
        lng: destination.lng,
      },
      measurementSystem: 'METRIC',
    })
      .then((response: any) => {
        const duration = `${Math.round(response?.data?.roadDistance?.durationInSeconds / 60)} min`;
        const distance = `${Math.round((response?.data?.roadDistance?.distance + Number.EPSILON) * 10) / 10} km`;

        if (props.onDistanceAndDurationResolved) {
          props.onDistanceAndDurationResolved(distance, duration);
        }
      });

    const directionsService = new maps.DirectionsService();
    const directionsRenderer = new maps.DirectionsRenderer();
    directionsRenderer.setMap(map);
    directionsService.route({
      origin,
      destination,
      travelMode: 'DRIVING',
    }, (response: any, status: string) => {
      if (status === 'OK') {
        directionsRenderer.setDirections(response);
        const routePolyline = new google.maps.Polyline({
          path: response.routes[0].overview_path,
        });
        routePolyline.setMap(map);
      } else {
        console.log('Error', status);
      }
    });
  };

  return (
    <div className="google-map-container">
      <GoogleMap
        center={center || position}
        defaultCenter={defaultCenter}
        defaultZoom={zoom}
        bootstrapURLKeys={{
          key: window.tz_globalConfigs.googleMapsApiKey,
          libraries: ['drawing'],
        }}
        yesIWantToUseGoogleMapApiInternals
        onGoogleApiLoaded={({ map, maps }) => handleGoogleApiLoaded(map, maps)}
      />
    </div>
  );
};
